import { gql } from 'graphql-tag';

export const INACTIVE_COFFEE_CUSTOMER_FIELDS = gql`
    fragment InactiveCoffeeCustomerFields on Customer {
        id
        uuid
        economic_number
        in_cup_agreement
        last_coffee_order_date
        days_since_last_coffee_order
        path
        user {
            id
            uuid
            name
            email
            status
            image {
                id
                file_path
            }
        }
        customer_group {
            id
            name
        }
    }
`;

export const PAGINATION = gql`
    fragment Pagination on CustomerPagination {
        total
        per_page
        current_page
        from
        to
        last_page
        has_more_pages
    }
`;

export default { INACTIVE_COFFEE_CUSTOMER_FIELDS, PAGINATION };
